module.exports = __webpack_public_path__ + "img/2中度牙缝问题.40dcf15d.gif";